import { APP_CONTEXT } from '@reducers/app/types';
import { getAppContext } from '../appContextObservable';
const Views = self => ({
    get app() {
        if (getAppContext() === APP_CONTEXT.SEARCH) {
            return self.search;
        }
        return self.prospecting;
    },
});
export default Views;
